import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/paperwork/${id}`);
  },
  async createPaperworkFromPaperworkSet(subgroup_id, paperwork_group_id) {
    return API.apiClient.post(`/subgroups/${subgroup_id}/paperwork-group/${paperwork_group_id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/paperwork/${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/paperwork`, data);
    } else {
      return API.apiClient.put(`/paperwork/${id}`, data);
    }
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async delete(id) {
    return API.apiClient.delete(`/paperwork/${id}`);
  }
};
